import _, { forIn } from 'lodash-es';

export const bedRateRunOptions = (data) => {
  console.log('==++-==',data)
  const x_data = [];
  const y_data = [];
  const colors = ['#063050', '#73C0DE', '#FAC858', '#8d4bbb'];
  let colorIndex = 0;
  forIn(data, (value, key) => {
    let label = '';
    if(key === 'allBoyRate') {
      label = '全托-男';
    } else if(key === 'allGirlRate') {
      label = '全托-女';
    } else if(key === 'noonBoyRate') {
      label = '午托-男';
    } else if(key === 'noonGirlRate') {
      label = '午托-女';
    }
    if(label) {
      x_data.push(label);
      y_data.push({
        value: (value*100).toFixed(2),
        itemStyle: { color: colors[colorIndex % colors.length] }
      });
      colorIndex++;
    }
  })

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '12%',
      top: '6%',
      containLabel: true
    },
    color: colors,
    xAxis: [
      {
        type: 'category',
        data: x_data,
        axisTick: {
          alignWithLabel: true
        }
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: [
      {
        name: '使用率(%)',
        type: 'bar',
        barWidth: '60%',
        data: y_data,
        label: {
          show: true,
          position: 'top',
          formatter: '{c}%'
        }
      }
    ]
  }
};
